/** @module error-utils */
import * as rawInvariant from 'invariant';

/**
 * @type {invariant}
 */
export const invariant = rawInvariant;



// WEBPACK FOOTER //
// ./node_modules/@xfe-team/utils/src/error-utils.js